module.exports = __webpack_public_path__ + "img/topbg.c6e38fe3.png";